module.exports = __webpack_public_path__ + "img/scania.36dbfdc5.png";